import { render, staticRenderFns } from "./CategoricalData.vue?vue&type=template&id=175b3438&scoped=true&"
import script from "./CategoricalData.vue?vue&type=script&lang=js&"
export * from "./CategoricalData.vue?vue&type=script&lang=js&"
import style0 from "./CategoricalData.vue?vue&type=style&index=0&id=175b3438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b3438",
  null
  
)

export default component.exports